import { apiGet, apiPost } from './index'

// 获取科室资源aifv内容
const getDepDevelop = (params) => apiGet(`/api/johnson/senior-director-info/getInfo/${params.multiCode}`)

// 获取大主任下面的医生返回列表
const getGrowthOverview = (params) => apiGet(`/api/johnson/senior-director/openListPage`, params)

// 活动详情
const trainDetails = (params) => apiGet(`/api/openapi/activity/detail/${params.key}`)

// 活动详情-课程列表
const trainDetailsCourse = (params) => apiGet(`/api/openapi/activity/course/${params.key}`)

// 活动详情-学员列表
const trainDetailstudent = (params) => apiGet(`/api/openapi/activity/student/${params.key}`)

// 活动详情-日程列表
const trainDetailSchedules = (params) => apiGet(`/api/openapi/activity/schedule/${params.key}`)

// 获取旅程报告内容
const xwzyJourneyReport = (params) => apiGet(`/api/johnson/senior-director/report/detail/multicode/${params.multiCode}`)

// 行稳致远 -- 获取token
const getTokenByxwzy = (params) => apiPost(`/api/openapi/iep/loginNoSign`, params)

// 行稳致远 -- 获取token -- 自定义分享pfa那块要用的
const getIssueTokenByxwzy = (params) => apiPost(`/api/auth/share/issue-token`, params)
export {
  trainDetails,
  trainDetailsCourse,
  trainDetailstudent,
  trainDetailSchedules,
  getDepDevelop,
  getGrowthOverview,
  xwzyJourneyReport,
  getTokenByxwzy,
  getIssueTokenByxwzy
}



// WEBPACK FOOTER //
// ./src/api/xwzy.js